import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "disabled",
  "use": "disabled-usage",
  "viewBox": "0 0 8 9",
  "content": "<symbol viewBox=\"0 0 8 9\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"disabled\">\n<path d=\"M6.6982 7.54932L1.00195 1.54932M1.30571 7.54932L7.00195 1.54932\" stroke=\"white\" stroke-width=\"2\" stroke-linecap=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol